enum BILLING_QUERY_KEYS {
  BILLING = 'billing',
  BILLING_TRANSACTIONS = 'transactions',
  BILLING_INSTALLMENTS = 'installments',
  BILLING_POLICY_BACKBILL = 'backbill',
  BILLING_ACCOUNTS = 'accounts',
  CANCELLED_PAYMENTS = 'canceledPayments',
  CHANGE_PAYMENT_PLAN = 'changePaymentPlan',
  AVAILABLE_PAYMENT_PLANS = 'availablePaymentPlans',
  PAYMENT_PLAN_PREVIEW = 'paymentPlanPreview',
  SUBMIT_CHANGE_PAYMENT_PLAN = 'submitChangePaymentPlan'
}

enum CLAIMS_QUERY_KEYS {
  CLAIMS = 'claims',
  RECENT_CLAIMS = 'recentClaims',
  CLAIM_MESSAGES = 'claimMessages',
  CLAIM_NEW_MESSAGES_COUNT = 'claimNewMessagesCount',
  CLAIMS_EMAIL_NOTIFICATION_PREFERENCES = 'claimsEmailNotificationPreferences'
}

enum POLICY_QUERY_KEYS {
  POLICIES = 'policies',
  POLICIES_SUMMARY = 'policiesSummaryInformation',
  POLICIES_SUMMARY_FOR_FNOL = 'fnolPolicies',
  POLICY_DETAILS = 'policyDetails',
  EDGE_POLICY_DETAILS = 'edgePolicyDetails',
  EDGE_POLICY_PAYMENT_PLANS = 'edgePolicyPaymentPlans'
}

enum EDIT_MORTGAGEE_QUERY_KEYS {
  EDIT_MORTGAGEE = 'editMortgagee',
  EDIT_MORTGAGEE_POLICY_CHANGE = 'policyChange'
}
enum UPDATE_LENDER_QUERY_KEYS {
  UPDATE_LENDER = 'updateLender',
  UPDATE_LENDER_POLICY_CHANGE = 'policyChange'
}
enum QUOTE_ADD_VEHICLE_QUERY_KEYS {
  QUOTE_ADD_VEHICLE = 'quoteAddVehicle',
  QUOTE_ADD_VEHICLE_POLICY_CHANGE = 'policyChange',
  QUOTE_ADD_VEHICLE_BOUND_POLICY = 'bind',
  QUOTE_ADD_VEHICLE_MAKE_MODEL_DATA = 'makeModel',
  QUOTE_ADD_VEHICLE_VIN_DATA = 'vinData'
}

enum EPROXY_QUERY_KEYS {
  EPROXY = 'eproxy',
  EPROXY_CAMPAIGN_DETAILS = 'campaignDetails',
  EPROXY_ELIGIBILITY = 'eligibility',
  EPROXY_EPROXIES = 'eproxies',
  EPROXY_AEM_CONTENT = 'eproxyAEMContent',
  EPROXY_NOTIFICATION_PREFERENCES = 'notificationPreferences'
}

enum ESIGN_QUERY_KEYS {
  ESIGN_DOCS = 'esignDocs',
  ESIGN_URL = 'esignUrl'
}

enum PRODUCT_AVAILABILITY_QUERY_KEYS {
  PRODUCT_AVAILABILITY = 'productAvailability'
}

enum MFA_QUERY_KEYS {
  MFA = 'mfa',
  ENROLLED_FACTORS = 'enrolledFactors',
  AVAILABLE_FACTORS = 'availableFactors'
}

enum QUOTING_QUERY_KEYS {
  QUOTING = 'quoting',
  QUOTING_QR_CODE = 'quoteQRCodeCustomer',
  AUTO_BASE_DATA = 'autoBaseData',
  HOME_BASE_DATA = 'homeBaseData',
  BASE_DRIVER = 'baseDriver',
  BASE_VEHICLE = 'baseVehicle',
  STANDARD_VIOLATION_CODES = 'standardViolationCodes',
  PRIOR_CARRIER = 'priorCarrier',
  BASE_PROPERTY = 'baseProperty',
  BASE_POLICY_HOLDER = 'basePolicyHolder',
  BASE_LOSS_COVERAGES = 'baseLossCoverages',
  LIFE = 'life',
  COVERAGE_CALCULATOR = 'coverageCalculator',
  LIFE_QUOTE_INPUTS = 'lifeQuoteInputs',
  LIFE_QUOTE_INPUTS_ID = 'lifeQuoteInputsId',
  LIFE_QUOTE_TOKEN = 'lifeQuoteToken',
  LIFE_QUOTE_INPUTS_CREATE = 'lifeQuoteInputsCreate',
  LIFE_QUOTE_INPUTS_UPDATE = 'lifeQuoteInputsUpdate',
  LIFE_QUOTE_GENERATE_QUOTE = 'lifeQuoteGenerateQuote',
  LIFE_QUOTE_START_APPLICATION = 'lifeQuoteStartApplication'
}

enum SEARCH_LENDERS_QUERY_KEYS {
  SEARCH_LENDERS = 'searchLenders'
}

enum PARTY_DOCUMENTS_QUERY_KEYS {
  PARTY_DOCUMENTS = 'partyDocuments'
}

enum HOME_PHOTO_UPLOAD_QUERY_KEYS {
  HOME_PHOTO_UPLOAD = 'homePhotoUpload',
  HOME_PHOTO_UPLOAD_CLAIMS_DETAILS = 'claimDetails'
}

enum ID_CARDS_QUERY_KEYS {
  ID_CARDS_BY_MAIL = 'idCardsByMail',
  ID_CARDS_BY_EMAIL = 'idCardsByEmail',
  EXPRESS_ID_CARDS = 'requestExpressIDCards'
}

enum PREFERENCE_QUERY_KEYS {
  PAPERLESS_UPDATE = 'update-paperless',
  PAPERLES_ENROLL = 'enroll-paperless',
  PAPERLESS_ENROLL_WITH_NEW_EMAIL = 'enroll-paperless-with-new-email',
  PAPERRLESS_UNENROLL = 'unenroll-paperless',
  PREFERENCES = 'preferences'
}

enum PARTY_QUERY_KEYS {
  PARTY = 'party',
  PHONES = 'phones',
  CREATE_OR_UPDATE_PHONE = 'createOrUpdatePhone',
  DELETE_PHONE = 'deletePhone',
  EMAILS = 'emails',
  CREATE_OR_UPDATE_EMAIL = 'createOrUpdateEmail',
  DELETE_EMAIL = 'deleteEmail',
  ADDRESSES = 'addresses',
  LIFE_ADDRESS = 'life_address',
  UPDATE_LIFE_ADDRESS = 'updateLifeAddress',
  TEXTING_ACCOUNT = 'textingAccount',
  TEXTING_ACCOUNT_CASES = 'textingAccountCases',
  CREATE_TEXTING_ACCOUNT = 'createTextingAccount',
  SET_TEXTING_PHONE = 'setTextingPhone',
  UPDATE_TEXTING_PREFERENCES = 'updateTextingPreferences',
  UPDATE_PAPERLESS_PREFERENCES = 'updatePaperlessPreferences'
}

enum PASSWORD_ACTION_QUERY_KEYS {
  UPDATE_PASSWORD = 'updatePassword'
}

enum EXPRESS_PAY_QUERY_KEYS {
  EXPRESS_PAY = 'expressPay'
}

enum EXPRESS_DOC_UPLOADER_KEYS {
  EXPRESS_DOC_UPLOADER = 'expressDocUploader'
}

enum CREATE_ACCOUNT_KEYS {
  GET_OKTA_AUTHORIZATION = 'getOktaAuthorization'
}

enum RESPONSE_HEADERS {
  RESPONSE_HEADERS = 'responseHeaders',
  RESPONSE_HEADER_LIFE_OUTAGE = 'lifeOutage',
  RESPONSE_HEADER_ACCOUNT_OUTAGE = 'accountOutage'
}

enum VIN_SEARCH {
  VIN_SEARCH = 'vinSearch'
}

enum CREATE_ACCOUNT {
  CREATE_ACCOUNT = 'createAccount',
  PROVISION_ACCOUNT = 'provisionAccount',
  PROVISION_ACCOUNT_WITH_LOGIN_ID = 'provisionAccountWithLoginId',
  VALIDATE_ACCOUNT = 'validateAccount'
}

export const QUERY_KEY = {
  ...ESIGN_QUERY_KEYS,
  ...CLAIMS_QUERY_KEYS,
  ...POLICY_QUERY_KEYS,
  ...BILLING_QUERY_KEYS,
  ...EDIT_MORTGAGEE_QUERY_KEYS,
  ...EPROXY_QUERY_KEYS,
  ...PRODUCT_AVAILABILITY_QUERY_KEYS,
  ...MFA_QUERY_KEYS,
  ...QUOTING_QUERY_KEYS,
  ...SEARCH_LENDERS_QUERY_KEYS,
  ...PARTY_DOCUMENTS_QUERY_KEYS,
  ...HOME_PHOTO_UPLOAD_QUERY_KEYS,
  ...ID_CARDS_QUERY_KEYS,
  ...PARTY_QUERY_KEYS,
  ...PREFERENCE_QUERY_KEYS,
  ...PASSWORD_ACTION_QUERY_KEYS,
  ...QUOTE_ADD_VEHICLE_QUERY_KEYS,
  ...EXPRESS_PAY_QUERY_KEYS,
  ...EXPRESS_DOC_UPLOADER_KEYS,
  ...CREATE_ACCOUNT_KEYS,
  ...RESPONSE_HEADERS,
  ...VIN_SEARCH,
  ...CREATE_ACCOUNT,
  ...UPDATE_LENDER_QUERY_KEYS
};

export type TYPE_QUERY_KEY =
  | ESIGN_QUERY_KEYS
  | CLAIMS_QUERY_KEYS
  | POLICY_QUERY_KEYS
  | BILLING_QUERY_KEYS
  | EDIT_MORTGAGEE_QUERY_KEYS
  | EPROXY_QUERY_KEYS
  | PRODUCT_AVAILABILITY_QUERY_KEYS
  | MFA_QUERY_KEYS
  | QUOTING_QUERY_KEYS
  | SEARCH_LENDERS_QUERY_KEYS
  | PARTY_DOCUMENTS_QUERY_KEYS
  | HOME_PHOTO_UPLOAD_QUERY_KEYS
  | ID_CARDS_QUERY_KEYS
  | PARTY_QUERY_KEYS
  | PREFERENCE_QUERY_KEYS
  | PASSWORD_ACTION_QUERY_KEYS
  | QUOTE_ADD_VEHICLE_QUERY_KEYS
  | EXPRESS_PAY_QUERY_KEYS
  | EXPRESS_DOC_UPLOADER_KEYS
  | CREATE_ACCOUNT_KEYS
  | RESPONSE_HEADERS
  | VIN_SEARCH
  | CREATE_ACCOUNT
  | UPDATE_LENDER_QUERY_KEYS;
